import { TransactionService } from '@/modules/transaction/transaction-service';
import Errors from '@/shared/error/errors';
// import { routerAsync } from '@/app-module';
// import Message from '@/shared/message/message';
// import { i18n } from '@/i18n';
import lodash from 'lodash';

import FirebaseRepository from '@/shared/firebase/firebase-repository';
import { firestoreAction, vuexfireMutations } from 'vuexfire'
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'

const INITIAL_PAGE_SIZE = 10;

export default {
  namespaced: true,

  state: {
    rows: [],
    count: 0,
    loading: false,
    filter: {},
    pagination: {},
    sorter: {},
    
    table: null,

    recentTransaction: [],
    recentTransactionLoading: false,
    
    loadMoreLastRecord: null,
    moreRowsPending: true,
    rowsBatch: [],
    incomeTransaction: [],
    expenseTransaction: [],
  },

  getters: {
    loading: (state) => state.loading,

    exportLoading: (state) => state.exportLoading,

    rows: (state) => state.rows || [],

    count: (state) => state.count,

    hasRows: (state, getters) => getters.count > 0,

    recentTransactionLoading: (state) => state.recentTransactionLoading,
    recentTransaction: (state) => state.recentTransaction || [],

    orderBy: (state) => {
      const sorter = state.sorter;

      if (!sorter) {
        return null;
      }

      if (!sorter.prop) {
        return null;
      }

      let direction =
        sorter.order === 'descending' ? 'DESC' : 'ASC';

      return `${sorter.prop}_${direction}`;
    },

    filter: (state) => state.filter,

    limit: (state) => {
      const pagination = state.pagination;

      if (!pagination || !pagination.pageSize) {
        return INITIAL_PAGE_SIZE;
      }

      return pagination.pageSize;
    },

    offset: (state) => {
      const pagination = state.pagination;

      if (!pagination || !pagination.pageSize) {
        return 0;
      }

      const currentPage = pagination.currentPage || 1;

      return (currentPage - 1) * pagination.pageSize;
    },

    pagination: (state, getters) => {
      return {
        ...state.pagination,
        total: getters.count,
        showSizeChanger: true,
      };
    },

    selectedRows: (state) => {
      return state.table ? state.table.selection : [];
    },

    loadMoreLastRecord: (state) => state.loadMoreLastRecord,
    moreRows: (state) => state.moreRowsPending,
    rowsBatch: (state) => state.rowsBatch || [],
    incomeTransaction: (state) => state.incomeTransaction || [],
    expenseTransaction: (state) => state.expenseTransaction || [],
  },

  mutations: {
    // adds Vuexfire built-in mutations
    ...vuexfireMutations,
    RESET_CURSOR(state) {
      state.loadMoreLastRecord = null
      state.moreRowsPending = true
      state.rowsBatch = []
      state.incomeTransaction = [],
      state.expenseTransaction = [],
      state.rows = []
      state.count = 0
    },
    ADD_AT_FIRST_ROWS(state, payload) {
      const myArray = state.rows
      myArray.unshift(payload)
      state.rows = myArray
    },
    MERGE_ROWS_BATCH(state, payload) {
      console.log(`Adding ${payload.length} to the list`)
      // const myArray = state.rows.concat(payload)
      // state.rows = [...new Set(myArray)]
      
      const myArray = lodash.concat(state.rows, payload)
      state.rows = lodash.uniqWith(myArray, lodash.isEqual)
    },
    SET_LOAD_MORE_LAST(state) {
      console.log('Setting last...')
      state.loadMoreLastRecord = state.rows[state.rows.length - 1]._doc
      state.rowsBatch = []
    },
    ALL_ROWS_LOADED(state) {
      state.moreRowsPending = false
    },
    VUEXFIRE_FETCH_STARTED(state) {
      state.loading = true;
    },
    VUEXFIRE_FETCH_SUCCESS(state, payload) {
      state.loading = false;
      state.rows = payload;
      state.count = payload.length;
      // state.rows = payload.rows;
      // state.count = payload.count;
    },
    VUEXFIRE_FETCH_ERROR(state) {
      state.loading = false;
      state.rows = [];
      state.count = 0;
    },


//#region [ default ]
    RESETED(state) {
      state.rows = [];
      state.count = 0;
      state.loading = false;
      state.filter = {};
      state.pagination = {};
      state.sorter = {};
      if (state.table) {
        state.table.clearSelection();
      }
    },

    UNSELECT_ALL(state) {
      if (state.table) {
        state.table.clearSelection();
      }
    },

    TABLE_MOUNTED(state, payload) {
      state.table = payload;
    },

    PAGINATION_CHANGED(state, payload) {
      state.pagination = payload || {};
    },

    PAGINATION_CURRENT_PAGE_CHANGED(state, payload) {
      const previousPagination = state.pagination || {};

      state.pagination = {
        currentPage: payload || 1,
        pageSize:
          previousPagination.pageSize || INITIAL_PAGE_SIZE,
      };
    },

    PAGINATION_PAGE_SIZE_CHANGED(state, payload) {
      const previousPagination = state.pagination || {};

      state.pagination = {
        currentPage: previousPagination.currentPage || 1,
        pageSize: payload || INITIAL_PAGE_SIZE,
      };
    },

    SORTER_CHANGED(state, payload) {
      state.sorter = payload || {};
    },

    FETCH_STARTED(state, payload) {
      state.loading = true;
      if (state.table) {
        state.table.clearSelection();
      }

      state.filter =
        payload && payload.filter ? payload.filter : {};
      state.pagination =
        payload && payload.keepPagination
          ? state.pagination
          : {};
    },

    FETCH_SUCCESS(state, payload) {
      state.loading = false;
      state.rows = payload.rows;
      state.count = payload.count;
      // state.rows = payload;
      // state.count = payload.length;
    },

    FETCH_ERROR(state) {
      state.loading = false;
      state.rows = [];
      state.count = 0;
    },

    EXPORT_STARTED(state) {
      state.exportLoading = true;
    },

    EXPORT_SUCCESS(state) {
      state.exportLoading = false;
    },

    EXPORT_ERROR(state) {
      state.exportLoading = false;
    },
    LOADING_FINISH(state){
      state.loading= false;
    },
//#endregion  

    FETCH_RECENT_TRANSACTION_STARTED(state) {
      state.recentTransactionLoading = true;
    },

    FETCH_RECENT_TRANSACTION_SUCCESS(state, payload) {
      state.recentTransaction = payload;
      state.recentTransactionLoading = false;
    },

    FETCH_RECENT_TRANSACTION_ERROR(state) {
      state.recentTransactionLoading = false;
      state.recentTransaction = [];
    },
  },

  actions: {
  //#region [ default ]  
    doUnselectAll({ commit }) {
      commit('UNSELECT_ALL');
    },
    doMountTable({ commit }, table) {
      commit('TABLE_MOUNTED', table);
    },

    doChangePagination(
      { commit, getters, dispatch },
      pagination,
    ) {
      commit('PAGINATION_CHANGED', pagination);
      const filter = getters.filter;
      dispatch('doFetch', { filter, keepPagination: true });
    },

    doChangePaginationPageSize(
      { commit, getters, dispatch },
      pageSize,
    ) {
      commit('PAGINATION_PAGE_SIZE_CHANGED', pageSize);
      const filter = getters.filter;
      dispatch('doFetch', { filter, keepPagination: true });
    },

    doChangePaginationCurrentPage(
      { commit, getters, dispatch },
      currentPage,
    ) {
      commit(
        'PAGINATION_CURRENT_PAGE_CHANGED',
        currentPage,
      );
      const filter = getters.filter;
      dispatch('doFetch', { filter, keepPagination: true });
    },

    doChangeSort({ commit, getters, dispatch }, sorter) {
      commit('SORTER_CHANGED', sorter);
      const filter = getters.filter;
      dispatch('doFetch', { filter, keepPagination: true });
    },

    async doReset({ commit, dispatch }) {
      commit('RESETED');
      return dispatch('doFetch');
    },

    async doFetch({ commit }, { filter, keepPagination } = {}) {
      try {
        commit('FETCH_STARTED', { filter, keepPagination });

        const response = await TransactionService.listOwnTransactions(filter, 'createdAt', {
          sortBy: "desc",
          limit: 10
        });

        console.log(response);
        commit('FETCH_SUCCESS', {
          rows: response.rows,
          count: response.count,
        });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },

    async doFetchTransactions(
      { commit },
      { filter } = {},
    ) {
      try {
        
        commit('FETCH_STARTED', { filter });
        const response = await TransactionService.listWalletTransactions(
          filter,
          'createdAt',
          {
            sortBy: "desc",
            limit: 10
        }
        );

        console.log("SUCCESS ",response.listWalletTransactions.rows);
        commit('FETCH_SUCCESS', {
          rows: response.listWalletTransactions.rows,
          count: response.listWalletTransactions.count,
        });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },

    async doFetchMyRecentTransactions({ commit }) {
      try {
        commit('FETCH_RECENT_TRANSACTION_STARTED');
        const response = await TransactionService.listMyRecentTransactions();
        commit('FETCH_RECENT_TRANSACTION_SUCCESS', response);
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_RECENT_TRANSACTION_ERROR');
      }
    },
  //#endregion

  //#region [ Vuexfire ]
    resetCursor({ commit }) {
      commit('RESET_CURSOR')
    },
    doFetchUserIncomeTransaction: firestoreAction(async (context, payload) => {
      try {
        const limit = payload.limit || 10
        context.commit('FETCH_STARTED')
        const customSerializer = (doc) => {
          // let data = doc.data()
          const data = FirebaseRepository.mapDocument(doc)
          Object.defineProperty(data, '_doc', { value: doc })
          if (context.getters.rows.length && context.getters.rows.length > limit ) {
            context.commit('ADD_AT_FIRST_ROWS', data)
          }
          return data
        }

        const db = firebase.firestore()
        const transactionQuery = db.collection('transaction')
          .where("payeeId", "==", payload.id)
          .orderBy('createdAt', 'desc')
          .limit(limit)
        await context.bindFirestoreRef(
          'rows',
          transactionQuery,
          { serialize: customSerializer }
        )
        context.commit('LOADING_FINISH')
        // .then((transactions) => {
        //   console.log(`Got ${transactions.length} transactions`)
        //   if(transactions.length > 0){
        //     // context.commit('MERGE_ROWS_BATCH', { transactions })
        //     context.commit('VUEXFIRE_FETCH_SUCCESS', transactions) 
        //     context.commit('SET_LOAD_MORE_LAST')
        //   }
        //   // set all loaded if we dont return as many as the limit
        //   if (transactions.length < limit) context.commit('ALL_ROWS_LOADED')
        // })
        // const response = await NotificationService.populateAll(getters.itemList)
        // commit('VUEXFIRE_FETCH_SUCCESS', response)   
        // context.commit('FETCH_SUCCESS')   
      } catch (error) {
        Errors.handle(error);
        context.commit('FETCH_ERROR');
      }  
    }),

    doFetchUserExpenseTransaction: firestoreAction(async (context, payload) => {
      try {
        const limit = payload.limit || 10
        context.commit('FETCH_STARTED')
        // debugger
        const customSerializer = (doc) => {
          // let data = doc.data()
          const data = FirebaseRepository.mapDocument(doc)
          Object.defineProperty(data, '_doc', { value: doc })
          if (context.getters.rows.length && context.getters.rows.length > limit ) {
            context.commit('ADD_AT_FIRST_ROWS', data)
          }
          return data
        }

        const db = firebase.firestore()
        const transactionQuery = db.collection('transaction')
          .where("payerId", "==", payload.id)
          .orderBy('createdAt', 'desc')
          .limit(limit)
          
        await context.bindFirestoreRef(
          'rows',
          transactionQuery,
          { serialize: customSerializer }
        )
        context.commit('LOADING_FINISH')
        // .then((transactions) => {
        //   console.log(`Got ${transactions.length} transactions`)
        //   if(transactions.length > 0){
        //     // context.commit('MERGE_ROWS_BATCH', { transactions })
        //     context.commit('VUEXFIRE_FETCH_SUCCESS', transactions) 
        //     context.commit('SET_LOAD_MORE_LAST')
        //   }
        //   // set all loaded if we dont return as many as the limit
        //   if (transactions.length < limit) context.commit('ALL_ROWS_LOADED')
        // })
        // const response = await NotificationService.populateAll(getters.itemList)
        // commit('VUEXFIRE_FETCH_SUCCESS', response)   
        // context.commit('FETCH_SUCCESS')   
      } catch (error) {
        Errors.handle(error);
        context.commit('FETCH_ERROR');
      }  
    }),
    
    async doFetchMoreIncomeTransaction({ commit, getters }, payload) {
      try {
        const limit = payload.limit || 10
        const transactionCollection = await firebase.firestore()
          .collection('transaction')
          .where("payeeId", "==", payload.id)
          .orderBy('createdAt', 'desc')
          .startAfter(getters.loadMoreLastRecord)
          .limit(limit)
          .get()

        let currentTransactions = []
        transactionCollection.docs.forEach(doc => {
          // let transaction = doc.data()
          let transaction = FirebaseRepository.mapDocument(doc)
          transaction['_doc'] = doc
          currentTransactions.push(transaction)
          // Object.defineProperty(transaction, '_doc', { value: doc })
          // commit('APPEND_TO_SECOND_BATCH', transaction)
        })
        // debugger
        
        console.log(`Got ${currentTransactions.length} transaction`)
        if(currentTransactions.length > 0){
          // context.commit('MERGE_ROWS_BATCH', { transaction })
          commit('MERGE_ROWS_BATCH', currentTransactions) 
          commit('SET_LOAD_MORE_LAST')
        }
        // set all loaded if we dont return as many as the limit
        if (currentTransactions.length < limit) commit('ALL_ROWS_LOADED')
        // commit('NEW_ROWS_LENGTH',transaction.docs.length)
        // getters.secondBatch = currentTransactions
        // commit('SET_LAST_RECORD_SECOND_BATCH')
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      } 
    }, 
    async doFetchMoreExpenseTransaction({ commit, getters }, payload) {
      try {
        const limit = payload.limit || 10
        const transactionCollection = await firebase.firestore()
          .collection('transaction')
          .where("payerId", "==", payload.id)
          .orderBy('createdAt', 'desc')
          .startAfter(getters.loadMoreLastRecord)
          .limit(limit)
          .get()

        let currentTransactions = []
        transactionCollection.docs.forEach(doc => {
          // let transaction = doc.data()
          let transaction = FirebaseRepository.mapDocument(doc)
          transaction['_doc'] = doc
          currentTransactions.push(transaction)
          // Object.defineProperty(transaction, '_doc', { value: doc })
          // commit('APPEND_TO_SECOND_BATCH', transaction)
        })
        // debugger
        
        console.log(`Got ${currentTransactions.length} transaction`)
        if(currentTransactions.length > 0){
          // context.commit('MERGE_ROWS_BATCH', { transaction })
          commit('MERGE_ROWS_BATCH', currentTransactions) 
          commit('SET_LOAD_MORE_LAST')
        }
        // set all loaded if we dont return as many as the limit
        if (currentTransactions.length < limit) commit('ALL_ROWS_LOADED')
        // commit('NEW_ROWS_LENGTH',transaction.docs.length)
        // getters.secondBatch = currentTransactions
        // commit('SET_LAST_RECORD_SECOND_BATCH')
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      } 
    }, 
  //#endregion

  },
};
